import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { LogLevel, setLogLevel } from '@angular/fire';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { environment } from '../environments/environment';
import { routes } from './app.routes';

setLogLevel(LogLevel.SILENT);

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		provideFirebaseApp(() => initializeApp(environment.firebase)),
		provideFirestore(() => getFirestore()),
		provideMessaging(() => getMessaging()),
		provideStorage(() => getStorage()),
		provideAuth(() => getAuth()),
		provideAnalytics(() => getAnalytics()),
		provideAnimations(),
		importProvidersFrom(
			CalendarModule.forRoot({
				provide: DateAdapter,
				useFactory: adapterFactory,
			}),
		),
		ScreenTrackingService,
		UserTrackingService,
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000',
		}),
	],
};
